// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KAXG","toggle":"styles_toggle__I8mQa","preview":"styles_preview__3a1IM"};